export enum AImagineActionType {
	// Trigger actions
	UPLOAD_INPUT_IMAGE = 'UPLOAD_INPUT_IMAGE',
	GENERATE_IMAGE = 'GENERATE_IMAGE',

	// Store actions
	STORE_GENERATED_IMAGE = 'STORE_GENERATED_IMAGE',

	// Loading / error
	SET_GENERATE_LOADING = 'SET_GENERATE_LOADING',
	SET_GENERATE_ERROR = 'SET_GENERATE_ERROR',
	CLEAR_GENERATE_ERROR = 'CLEAR_GENERATE_ERROR',

	// Form / UI state
	SET_TOOL = 'SET_TOOL',
	SET_TOOL_OPTIONS = 'SET_TOOL_OPTIONS',
	SET_PROMPT = 'SET_PROMPT',
	SET_AREA_NAME = 'SET_AREA_NAME',
	SET_UPLOADED_IMAGE = 'SET_UPLOADED_IMAGE',
	RESET_STATE = 'RESET_STATE'
}

export enum AImagineTool {
	STAGE = 'STAGE',
	RESTYLE = 'RESTYLE',
	FLOORING = 'FLOORING',
	WALLPAINT = 'WALLPAINT',
	OBJECTS = 'OBJECTS',
	THEMER = 'THEMER',
	CEILING = 'CEILING',
	RENDER = 'RENDER'
}

export enum ObjectAction {
	ADD = 'ADD',
	REMOVE = 'REMOVE',
	REPLACE = 'REPLACE'
}
